import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "m2 9 3-3 3 3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M13 18H7a2 2 0 0 1-2-2V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m22 15-3 3-3-3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M11 6h6a2 2 0 0 1 2 2v10", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Repeat2";
const Repeat2 = memo(themed(Icon));
export {
  Repeat2
};
//# sourceMappingURL=repeat-2.js.map
